import axios from 'axios';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';





const CUET_SectionModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    const [subjects, setSubjects] = useState([]);
    const [selectedSubjects, setSelectedSubjects] = useState([]);

    let initialData = {
        ExamType: 'Section-IA',
        Section: '',
        SubjectType: 'Select SUBJECT NAME',
        SubjectTypeID: 0,
        Sn: 0,

    }


    const [examBodyData, setExamBodyData] = useState(initialData);


    console.log(examBodyData);
    useImperativeHandle(ref, () => ({
        openModal(item = {}) {
            if (item.Sn > 0) {
                setExamBodyData(item)
                setSelectedSubjects(subjects.filter((subject) => subject.ExamType === item.ExamType));
            } else {
                const newData = { ...initialData, ...item };
                setExamBodyData(newData);
                if (newData.ExamType) {
                    setSelectedSubjects(subjects.filter((subject) => subject.ExamType === newData.ExamType));
                }
            }
            setModalBox(true);

        }
    }));

    useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/cuet/subjects').then((response) => {
            setSubjects(response.data.subjects);
            setSelectedSubjects(response.data.subjects.filter((subject) => subject.ExamType === examBodyData.ExamType));

        }).catch((error) => {
            console.error('Error fetching subjects:', error);
            toast.error('Failed to fetch subjects');
        }
        );
    }, []);

    const hanldeSaveExamBody = async () => {
        try {
            if (examBodyData.Section.trim().length === 0) {
                toast.error("Please Enter Section Name")
                return;
            } else if (examBodyData.SubjectType.trim().length === 0 || examBodyData.SubjectType === 'Select Subject Type') {
                toast.error("Please select Subject type")
                return;
            }
            const response = await axios.post(BACKEND_SERVER_URL + `${!examBodyData.Sn ? '/cuet/createSection' : `/cuet/updateSection`}`, examBodyData);
            toast.success(response.data.message);
        } catch (error) {
            console.log(error)
            toast.error(error?.response?.data?.message)
        } finally {
            props.setSubjectLoading(!props.loadSubjects);
            setExamBodyData(initialData)
            setModalBox(false);
            setExamBodyData(initialData);
        }

    }
    console.log(subjects);
    return (
        <>
            <Modal onHide={setModalBox} show={modalBox} size="md" backdrop="static"
                keyboard={false} >
                <div className="modal-content">
                    <div className="modal-header">
                        {/* <h5 className="modal-title" id="exampleModalLabel"> {examBodyData.Sn ? "Update Section" : "Add Section"}</h5> */}
                        <h5 className="modal-title" id="exampleModalLabel"> {examBodyData.Sn ? "Update TOPICS" : "Add TOPICS"}</h5>
                        <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label htmlFor="sessioncount" className="form-label text-primary">All SUBJECT<span className="required">*</span></label>
                            <Select
                                value={(() => {
                                    const options = [
                                        { value: 'Section-IA', label: 'Language Subjects' },
                                        { value: 'Section-II', label: 'Domain-Specific Subjects' },
                                        { value: 'Section-III', label: 'General Aptitude Test' }
                                    ];
                                    return options.find(opt => opt.value === examBodyData.ExamType) || { value: examBodyData.ExamType, label: examBodyData.ExamType };
                                })()}
                                onChange={(selectedOption) => {
                                    setExamBodyData({ ...examBodyData, ExamType: selectedOption.value });
                                    setSelectedSubjects(subjects.filter((subject) => subject.ExamType === selectedOption.value));
                                }}
                                options={[
                                    { value: 'Section-IA', label: 'Language Subjects' },
                                    { value: 'Section-II', label: 'Domain-Specific Subjects' },
                                    { value: 'Section-III', label: 'General Aptitude Test' }
                                ]}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: '100%',
                                        backgroundColor: 'transparent', // Adjust as needed
                                        borderColor: '#17a2b8', // Adjust as needed

                                    }),
                                }}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="sessioncount" className="form-label text-primary">SUBJECT NAME<span className="required">*</span></label>
                            <Select
                                value={{ value: examBodyData.SubjectType, label: examBodyData.SubjectType }}
                                onChange={(selectedOption) => {
                                    setExamBodyData({ ...examBodyData, SubjectType: selectedOption.value.SubjectType, SubjectTypeID: selectedOption.value.Sn })
                                }}
                                options={selectedSubjects?.map((course) => ({ value: course, label: course.SubjectType }))}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: '100%',
                                        backgroundColor: 'transparent', // Adjust as needed
                                        borderColor: '#17a2b8', // Adjust as needed

                                    }),
                                }}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="subjects" className="form-label text-primary">TOPICS<span className="required">*</span></label>
                            <input autoFocus className='form-control' type="text" name="" id="subjects" value={examBodyData.Section} onChange={(e) => setExamBodyData({ ...examBodyData, Section: e.target.value })} />
                        </div>



                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                        <button type="button" className="btn btn-primary btn-xs " onClick={hanldeSaveExamBody}>{examBodyData.Sn ? "Update" : "Add TOPICS"}</button>
                    </div>
                </div>
            </Modal>

        </>
    )
})
export default CUET_SectionModal;